import type { FC, PropsWithChildren } from 'react'
import { Box, List, Subtitle2 } from '@dhl-ui/components'

type Props = {
  title: string
}

export const SearchResultList: FC<PropsWithChildren<Props>> = ({ title, children }) => (
  <Box>
    <Box py={2} px={2}>
      <Subtitle2>{title}</Subtitle2>
    </Box>
    <List>{children}</List>
  </Box>
)
